import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IPoint {
  id: number;
  name: string;
  legalName: string;
  address: string;
  addressGoogle1: string | null;
  addressGoogle2: string | null;

  /**
   * Ham DB değeri: derece × 10^7 tamsayı metni (ör. "408849220"); boşsa null.
   * Dereceye çevirmek için `utils/pointCoordinates` (describeStoredLocation) — burada
   * dönüştürülmez: eski `Number(v)/1e7` null'ı 0'a çeviriyor, hatalı ölçekli kaydı gizliyordu.
   */
  lat: string | null;
  loc: string | null;

  subcityId: number;
  postcode: string | null;
  taxId: string;
  taxOffice: string;
  days: string | null;
  times: string | null;
  minutes: string | null;
  region: number;
  phone: string;
  image: string | null;
  email: string | null;
  bolge: number | null;
  districtId?: number | null;
}

export class IPostPointBodyDto {
  name: string;
  legalName?: string;
  address: string;
  addressGoogle1?: string;
  addressGoogle2?: string;
  /** derece × 10^7 tamsayı metni — `buildLocationCreate` */
  lat?: string;
  loc?: string;
  subcityId: number;
  postcode?: string | null;
  taxId?: string;
  taxOffice?: string;
  days?: string | null;
  times?: string;
  minutes?: string;
  region?: number;
  phone?: string;
  image?: string;
  email?: string | null;
  bolge?: number | null;
  public: number;
  districtId?: number | null;
}

export class IPatchPointBodyDto {
  name?: string;
  legalName?: string;
  address?: string;
  addressGoogle1?: string;
  addressGoogle2?: string;
  /** derece × 10^7 tamsayı metni, null konumu temizler — `buildLocationPatch` (lat ve loc birlikte) */
  lat?: string | null;
  loc?: string | null;
  subcityId?: number;
  cityId?: number;
  postcode?: string | null;
  taxId?: string;
  taxOffice?: string;
  days?: string | null;
  times?: string | null;
  minutes?: string | null;
  region?: number;
  phone?: string;
  image?: string;
  email?: string | null;
  bolge?: number;
  districtId?: number | null;
}

export class IPatchPointMapBodyDto {
  from_point?: string | number;
  to_point?: string | number;
  route?: string | number;
  status?: number;
  has_return?: number;
  dirty?: number;
  public?: number;
}

export class IPointResponse {
  @Type(() => IPoint)
  result: IPoint;
}

export class IPointListResponse extends IPagination {
  @Type(() => IPoint)
  results: IPoint[];
}

export class IPointMap {
  id: number;
  from_point: number;
  to_point: number;
  route: number;
  status: number;
  has_return: number;
  dirty: number;
  sync_to: number;
  public?: number;
}

export class IPostPointMapBodyDto {
  from_point: number;
  to_point: number;
  route: number;
  status: number;
  has_return: number;
  dirty: number;
  firma_iademi: number;
  sync_to: number | null;
  public: number;
}

export class IPointMapResponse {
  @Type(() => IPointMap)
  result: IPointMap;
}

export class IPointMapListResponse {
  @Type(() => IPointMap)
  results: IPointMap[];
}

export class IPointQueryDto extends IQueryPaginationDto {
  bolge?: number;
  name?: string;
  legalName?: string;
  address?: string;
  subCityId?: number;
  taxId?: string;
  taxOffice?: string;
}

export class IPointMapQueryDto extends IQueryPaginationDto {
  to_point?: string | number;
  status?: number;
  from_point?: string | number;
  route?: string | number;
  public?: number;
}
